export default __webpack_public_path__ + "img/smooth_loader.693b7c7e2301edf6b805c3c3c46762bb.svg";